import angular from 'angular';
import progressRingComponent from './progress-ring.component';

let progressRingModule = angular.module('progressRing', [])
  .component('progressRing', progressRingComponent);

export default progressRingModule;




// WEBPACK FOOTER //
// ./client/common/directives/progress-ring/progress-ring.js